import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import config from "./config";

import BucarPacienteProgramacionCirugia from "./pages/BucarPacienteProgramacionCirugia";
import PacientesCirugias from "./pages/PacientesCirugias";
// import Prueba from "./pages/Prueba";
//import TabsRender from "./pages/TabsRender";
// import ModalSeleccionTipoSuministro from "./components/cirugia/modalProcedimiento/ModalSeleccionTipoSuministro"
//import ErrorCirugia from "./components/mensaje/ErrorCirugia";
//import ModalEliminarProcedimiento from "./components/cirugia/modalProcedimiento/ModalEliminarProcedimiento";
import DescripcionQuirurgica from "./components/cirugia/descripcionQuirurgica/DescripcionQuirurgica";
//import AppDos from "./pagination/AppDos";
import HojaDeGasto from "./components/cirugia/hojaGasto/HojaDeGasto";
import LiquidacionQx from "./components/cirugia/liquidacion/LiquidacionQx";
import DespachoQXFarmacia from "./components/farmacia/despachoQx/DespachoQXFarmacia";
import DevolucionesQxFarmacia from "./components/farmacia/devolucionQx/DevolucionesQxFarmacia";
// import LoadingModal from "./components/LoadingModal";
import ModalSuministrosUsadosDespachadosSolicitadosDevueltos from "./components/cirugia/estadisticas/ModalSuministrosUsadosDespachadosSolicitadosDevueltos";
import ModalTotalProcedimientosQx from "./components/cirugia/estadisticas/ModalTotalProcedimientosQx";
import Navbar from "./components/observaciones/Navbar";
import ReservarCX from "./components/cirugia/reservarCx/ReservarCX";
import ConfirmarCX from "./components/cirugia/confirmarCx/ConfirmarCX";
import GestionCX from "./components/cirugia/gestionCx/GestionCX";
import ConsolidadoEstados from "./components/cirugia/consolidado/ConsolidadoEstados";

import ModalReimprimirDespachosFarmacia from "./components/farmacia/ReimprimirDespachos/ModalReimprimirDespachosFarmacia";
import RecordAnestesia from "./components/cirugia/recordAnestesia/RecordAnestesia";
import TurnosQuirofanos from "./components/cirugia/turnosQuirofanos/TurnosQuirofanos";
import ModalEstadosTotalTiempoCalcularMedia from "./components/cirugia/estadisticas/ModalEstadosTotalTiempoCalcularMedia";
// import ControlAgenda from "./components/Pruebas/ControlAgenda";
//import ModalConsentimientoInformado from "./pages/ModalConsentimientoInformado";
import FormasDeLiquidacion from "./components/contratacion/formasDeLiquidacion/FormasDeLiquidacion";
import VigilanciaEpidemiologicaPrincipal from "./components/contralEnfermeria/vigilanciaEpidemiologica/VigilanciaEpidemiologicaPrincipal";
import PrincipalProcedimientosIndividuales from "./components/contratacion/procedimientosIndividuales/PrincipalProcedimientosIndividuales";
import ListaDeChequeoPreparacionPreoperatoriaPrincipal from "./components/cirugia/listaChequeoPreparacion/ListaDeChequeoPreparacionPreoperatoriaPrincipal";
import PaquetesQuirurgicosPrincipal from "./components/clinico/paquetesQX/PaquetesQuirurgicosPrincipal";
import ModalFirmaConsentimientoInformado from "./components/cirugia/reservarCx/ModalFirmaConsentimientoInformado";
import PrincipalConsentimientoInformado from "./components/consentimientoInformadoAdmisiones/PrincipalConsentimientoInformado";
import ResultadosProcedimientosPrincipal from "./components/clinico/resultadosProcedimientos/ResultadosProcedimientosPrincipal";
import FormasFarmaceuticasPrincipal from "./components/Suministros/formasFarmaceuticas/FormasFarmaceuticasPrincipal";
import MaestroConcentracionPrincipal from "./components/Suministros/maestroConcentracion/MaestroConcentracionPrincipal";
import FirmaMedicoPrincipal from "./components/clinico/firmaMedico/FirmaMedicoPrincipal";
import ProcedimientosNoOperacionales from "./components/contratacion/procedimientosNoOperacionales/ProcedimientosNoOperacionales";
// import ModalProgramacionDeUnaCirugiaN from "./components/cirugia/programacionDeUnaCirugia/ModalProgramacionDeUnaCirugiaN";
//import ControlAgenda from './components/Pruebas/ControlAgenda';



function App() {
  //local y produccion pruebas
  // const routerName= '/dashboard'
  

  //clinica cartagena
  //const routerName= '/his_opedale_cirugia/build'

  //clinica estancia
  // const routerName= '/his_cirugia'

  return (
  <BrowserRouter basename={config.ROUTER_NAME}>
      <Routes>
        <Route path="/pacientescirugia" element={<PacientesCirugias />} />        
        <Route path="/buscarpacienteprogramacioncirugia" element={<BucarPacienteProgramacionCirugia/>}/>        
        <Route path="/descripcionquirurgica" element={<DescripcionQuirurgica/>}/>
        <Route path="/hojadegasto" element={<HojaDeGasto/>}/>
        <Route path="/liquidacion" element={<LiquidacionQx/>}/>
        <Route path="/farmacia-despachoqx" element={<DespachoQXFarmacia/>}/>
        <Route path="/farmacia-devolucionqx" element={<DevolucionesQxFarmacia/>}/>
        <Route path="/reservarcx" element={<ReservarCX/>}/>
        <Route path="/confirmarcx" element={<ConfirmarCX/>}/>
        <Route path="/gestioncx" element={<GestionCX/>}/>
        <Route path="/consolidadocx" element={<ConsolidadoEstados/>}/>
        <Route path="/reimprimirdespacho" element={<ModalReimprimirDespachosFarmacia/>}/>
        <Route path="/recordanestesia" element={<RecordAnestesia/>}/>
        <Route path="/turnosquirofanos" element={<TurnosQuirofanos/>}/>
        <Route path="/formas-liquidacion" element={<FormasDeLiquidacion/>}/>
        <Route path="/vigilancia-epidemiologica" element={<VigilanciaEpidemiologicaPrincipal/>}/>
        <Route path="/procedimientos-individuales" element={<PrincipalProcedimientosIndividuales/>}/>
        <Route path="/paquetesquirurgicos" element={<PaquetesQuirurgicosPrincipal />}/>
        <Route path="/consentimientoInformado" element={<PrincipalConsentimientoInformado/>}/>
        <Route path="/resultadosProcedimientos" element={<ResultadosProcedimientosPrincipal/>}/>
        <Route path="/formasFarmaceuticas" element={<FormasFarmaceuticasPrincipal/>}/>
        <Route path="/maestroConcentracion" element={<MaestroConcentracionPrincipal/>}/>
        <Route path="/firmaMedico" element={<FirmaMedicoPrincipal/>}/>
        <Route path="/ProcedimientosNoOperacionales" element={<ProcedimientosNoOperacionales/>}/>
        {/* <Route path="/prueba" element={<Prueba/>}/> */}
        {/* <Route path="/tabs" element={<TabsRender/>}/> */}
        <Route path="/suministrosTotal" element={<ModalSuministrosUsadosDespachadosSolicitadosDevueltos/>}/>
        <Route path="/totalProcedimientos" element={<ModalTotalProcedimientosQx/>}/>
        <Route path="/observacion" element={<Navbar/>}/>
        <Route path="/estadosTotal" element={<ModalEstadosTotalTiempoCalcularMedia />}/>
        {/* <Route path="/spinner" element={<LoadingModal/>} /> */}
        {/* <Route path="/procedimiento/suministro" element={<ModalSeleccionTipoSuministro/>}/> */} 
        {/* <Route path="/controlAgenda" element={<ControlAgenda />}/> */}
        {/* <Route path="/programacioncirugia" element={<ModalProgramacionDeUnaCirugiaN />}/> */}
        <Route path="/listachequeo" element={<ListaDeChequeoPreparacionPreoperatoriaPrincipal/>}/>
        <Route path="/firma" element={<ModalFirmaConsentimientoInformado />}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
